import { useEffect, useState } from 'react';
import usePaymentResultRefresh from '../hooks/usePaymentResultRefresh';

export default function PaymentResultMonitor({ rows, refresh }) {
  const [message, setMessage] = useState('');
  const polling = usePaymentResultRefresh(rows, refresh, row => {
    setMessage(String(row.transactionType ?? row.transaction_type ?? '').toUpperCase() === 'CANCEL'
      ? '확인 결과 취소가 완료되었습니다.' : '확인 결과 결제가 승인되었습니다.');
  });
  useEffect(() => {
    const refresh = () => polling.check();
    window.addEventListener('payment-result-refresh', refresh);
    return () => window.removeEventListener('payment-result-refresh', refresh);
  }, [polling.check]);
  if (!polling.hasUnknown && !message) return null;
  return <div className="m-3 flex flex-wrap items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900" role="status">
    <span className="flex-1">{message || (polling.expired ? '아직 결과가 확인되지 않았습니다. 수동으로 다시 확인하거나 관리자에게 문의해 주세요.' : '결과 확인이 필요한 거래가 있습니다. 자동으로 결과를 확인 중입니다.')}</span>
    <button type="button" disabled={polling.checking} onClick={polling.check} className="rounded border border-amber-300 bg-white px-3 py-2 disabled:opacity-50">{polling.checking ? '확인 중…' : '결과 다시 확인'}</button>
    {message && <button aria-label="안내 닫기" onClick={() => setMessage('')}>닫기</button>}
  </div>;
}
